import { render, staticRenderFns } from "./EmailGroupFilter.vue?vue&type=template&id=0b827f22&"
import script from "./EmailGroupFilter.vue?vue&type=script&lang=ts&"
export * from "./EmailGroupFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports